(function(){
  function init(){
    if(!document.querySelector('.wk-nightveil')){var veil=document.createElement('div');veil.className='wk-nightveil';veil.setAttribute('aria-hidden','true');document.body.prepend(veil)}
    var wheel=document.querySelector('.wk-wtab');
    document.querySelectorAll('.wk-crypt-callout').forEach(function(box){box.hidden=!wheel||wheel.hidden});
    document.querySelectorAll('.wk-open-wheel').forEach(function(button){button.addEventListener('click',function(){if(wheel&&!wheel.hidden)wheel.click()})});
    var watch=document.querySelector('.wk-watch'),screen=watch&&watch.querySelector('.wk-scr');
    if(screen&&!screen.querySelector('iframe')){
      screen.setAttribute('data-yt','nvpatm2Wc3s');screen.setAttribute('data-t','YEAH YEAH');
      var image=screen.querySelector('img');if(image){image.src='https://i.ytimg.com/vi/nvpatm2Wc3s/hqdefault.jpg';image.alt='YEAH YEAH — LIL BRUH GWOP'}
      var cap=screen.querySelector('.cap');if(cap&&cap.firstChild&&cap.firstChild.nodeType===3)cap.firstChild.textContent='YEAH YEAH ';
      watch.querySelectorAll('[data-yt]').forEach(function(button){if(button!==screen)button.classList.toggle('on',button.getAttribute('data-yt')==='nvpatm2Wc3s')});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
